import { MediaSource } from '../../types/media';
import { IImportedMediaItem } from './imported/types';
import { IUploadedMediaItem, UploadStatus } from './uploads/types';

type IMediaItem = IImportedMediaItem | IUploadedMediaItem;

function isImported(item: IMediaItem): item is IImportedMediaItem {
  return (
    item.source === MediaSource.FACEBOOK || item.source === MediaSource.SITE
  );
}

function isUpload(item: IMediaItem): item is IUploadedMediaItem {
  return item.source === MediaSource.UPLOAD;
}

function isUploadInProgress(item: IMediaItem): item is IUploadedMediaItem {
  return isUpload(item) && item.status === UploadStatus.NEW;
}

export { IMediaItem, isImported, isUploadInProgress, isUpload };
